
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft10 as ObiWindShaft10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-10.js';
 
 
 

 
 export const ObiWindShaft10 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-10',
   elementClass: ObiWindShaft10Element,
   events: {
     
   }
  });
 
 